import { observer } from "mobx-react";
import { FormattedMessage } from "react-intl";
import { calculateSummary, formatNumberWithCommas, getOptionNameFromServiceName } from "../../../constants/constants";
import { serviceTypeEnum } from "../../../constants/enums/service-type-enum";
import { useStore } from "../../../contexts/store-provider";
import { IOption } from "../../../models/ICommon";
import {
  ISaleItemVM,
  ISaleRecordVM,
} from "../../../models/response/ISMRResponse";
import { formatMessage } from "../../../translations/format-message";
interface IProps {
  saleItems: ISaleItemVM[];
  products: ISaleItemVM[];
  treatments: ISaleItemVM[];
  options: ISaleItemVM[];
  saleRecordInfo: ISaleRecordVM;
}
const TreatmentMenuCard = (props: IProps) => {
  const { masterManagementStore } = useStore();
  const { getAllStaffOptions, consumptioTaxSetting } = masterManagementStore;

  const invoiceSummary = calculateSummary(
    props.saleRecordInfo,
    props.saleItems,
    getAllStaffOptions,
    consumptioTaxSetting,
    null,
    false,
    props.saleRecordInfo.NominationFee,
  );

  return (
    <div className="border p-3">
      <h3 className="mb-2">{formatMessage("menu")}</h3>
      <div className=" position-relative">        
        {props.treatments?.map((item: ISaleItemVM, index: number) => {
          const staffName = getAllStaffOptions.find(
            (option: IOption) => option.id === item?.StaffId
          )?.value;

          const selectedOptions = props.options.reduce(
            (
              acc: ISaleItemVM[],
              optionItem: ISaleItemVM
            ) => {
              if (
                optionItem.ItemType ===
                serviceTypeEnum.Option
              ) {
                const [id, name] =
                  optionItem.ItemName.split("_");
                if (id === item.ItemId.toString()) {
                  acc.push({
                    ...optionItem,
                    ItemName:
                      getOptionNameFromServiceName(
                        optionItem.ItemName
                      ),
                  });
                }
              }
              return acc;
            },
            []
          );

          return (
            <>
              <div className="row g-2">
                <div className="col-12 col-xl-3 col-xxl-2">
                  {index === 0 && (
                    <span className="badge bg-danger px-4">
                      {formatMessage("treatment")}
                    </span>
                  )}
                </div>
                <div className="col-12 col-md-8 col-xl-6 col-xxl-6">
                  <p className="mb-0">{item.ItemName}</p>
                  <p className="mb-1 small text-muted">{staffName}</p>
                </div>
                <div className="col-12 col-md-4 col-xl-3 text-end">
                  <p className="text-end">
                  <i className="bi bi-currency-yen"></i>{formatNumberWithCommas(item.Price)}
                  </p>
                </div>
              </div>
                {selectedOptions.map(
                  (option: any, index2: number) => {
                    const optionStaffName = getAllStaffOptions.find(
                      (option2: IOption) => option2.id === option?.StaffId
                    )?.value;
                    return (<>
                    <div className="row g-2">
                      <div className="col-12 col-xl-3 col-xxl-2">
                        
                      </div>
                      <div className="col-12 col-md-8 col-xl-6 col-xxl-6">
                        <p className="mb-0">{option.ItemName}
                          <span className="badge bg-primary rounded ms-2">
                            <FormattedMessage id="option" />
                          </span>
                        </p>
                        <p className="mb-1 small text-muted">{optionStaffName}</p>
                      </div>
                      <div className="col-12 col-md-4 col-xl-3 text-end">
                        <p className="text-end">
                        <i className="bi bi-currency-yen"></i> {formatNumberWithCommas(option.Price)}
                        </p>
                      </div>
                    </div>
                    </>)
                  })
                }
            </>
          );
        })}
      </div>
      <div className=" position-relative">
        {props.products?.map((productItem: ISaleItemVM, index: number) => {
          const staffName = getAllStaffOptions.find(
            (option: IOption) => option.id === productItem?.StaffId
          )?.value;

          return (
            <div className="row g-2">
              <div className="col-12 col-xl-3 col-xxl-2">
                {index === 0 && (
                  <span className="badge bg-danger px-4">
                    {formatMessage("merchandise")}
                  </span>
                )}
              </div>
              <div className="col-12 col-md-8 col-xl-6 col-xxl-6">
                <p className="mb-0">{productItem.ItemName}</p>
                <p className="mb-1 small text-muted">{staffName}</p>
              </div>
              <div className="col-12 col-md-4 col-xl-3 text-end">
                <p className="text-end">
                <i className="bi bi-currency-yen"></i>{formatNumberWithCommas(productItem.Price)}
                  <br />
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="row g-2 mt-4">
        <div className="col-12 col-xl-3 col-xxl-2">
          <span className="badge bg-primary px-4">{formatMessage("sum")}</span>
        </div>
        <div className="col-12 col-xl-9 col-xxl-10 text-end">
          <small className="text-muted">
            ({formatMessage("total_tax")}: <i className="bi bi-currency-yen me-1"></i>{formatNumberWithCommas(invoiceSummary.TaxTotal + invoiceSummary.ConsumptionTax)}{" "}
            {/* <i className="bi bi-currency-yen"></i> */}
            )
          </small>
          <p className="fw-bold"><i className="bi bi-currency-yen"></i> {formatNumberWithCommas(invoiceSummary.TotalAmount)}</p>
        </div>
      </div>
    </div>
  );
};

export default observer(TreatmentMenuCard);
